var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage3211(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 238,
    viewBox: "0 0 280 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.1201 160.876L74.1085 139.19H106.938L84.7677 160.876H52.1201Z",
    fill: "url(#paint0_linear_1242_188)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M227.723 87.1176C250.052 81.3326 265.83 67.6752 262.964 56.6129C260.098 45.5506 239.672 41.2725 217.343 47.0575C195.013 52.8425 179.235 66.4999 182.102 77.5621C184.968 88.6244 205.393 92.9025 227.723 87.1176Z",
    fill: "#DBFFF7",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M269.085 52.5595L176.095 87.4364L171.79 70.8214L265.002 47.3411L269.085 52.5595Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M241.657 68.4307C241.657 68.4307 250.555 66.6136 248.204 58.2664",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.778 69.2038C133.371 58.7392 119.971 42.7409 98.848 33.4707C77.7249 24.2004 56.8778 25.1686 52.2845 35.6332C47.6913 46.0978 61.0914 62.0961 82.2145 71.3663C103.338 80.6366 124.185 79.6684 128.778 69.2038Z",
    fill: "#DBFFF7",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9014 30.6522L133.146 79.9069L140.045 64.189L51.7624 26.1549L46.9014 30.6522Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4455 50.697C71.4455 50.697 62.95 47.4887 66.6071 39.6184",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5113 109.184C97.3869 106.102 107.397 98.0283 105.869 91.1523C104.341 84.2762 91.8539 81.2011 77.9784 84.2839C64.1028 87.3666 54.0931 95.4399 55.621 102.316C57.1489 109.192 69.6358 112.267 83.5113 109.184Z",
    fill: "#DBFFF7",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1265 101.803L111.935 94.8922L109.641 84.5631L51.9045 97.7995L51.1265 101.803Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6278 102.831C70.6278 102.831 65.2386 104.33 64.188 99.0886",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M148.575 228.267V201.011H160.853V228.267H174.033V170.762L132.101 129.428H68.2935L27.2583 170.762L90.1626 171.358H147.377",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M159.058 171.358H174.033",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6797 226.768H57.515C57.515 226.768 57.2368 217.597 67.1009 218.682C73.2397 219.358 74.489 226.768 74.489 226.768",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3008 226.768C65.3008 226.768 65.3973 215.445 78.3961 215.701C88.0218 215.888 90.1627 226.768 90.1627 226.768V171.358L132.101 129.423",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2583 170.762V226.768",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1201 161.177L74.2391 139.059H106.938L84.4724 161.177H52.1201Z",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1963 161.177L91.1847 139.19",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1768 150.115H95.7051",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6225 184.237H36.2422V195.616H47.6225V184.237Z",
    fill: "white",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2021 184.237H57.8218V195.616H69.2021V184.237Z",
    fill: "white",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M122.015 184.237H110.635V195.616H122.015V184.237Z",
    fill: "white",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M128.506 83.8988L153.368 64.1322L172.835 88.6914L148.274 108.759L128.506 83.8988Z",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M128.506 83.8988L172.835 88.6914",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M150.671 90.8605C153.111 90.8605 155.089 88.8826 155.089 86.4427C155.089 84.0028 153.111 82.0249 150.671 82.0249C148.231 82.0249 146.252 84.0028 146.252 86.4427C146.252 88.8826 148.231 90.8605 150.671 90.8605Z",
    fill: "url(#paint1_linear_1242_188)",
    stroke: "#005E4C",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M134.139 79.4128L88.0669 59.0386",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M169.036 83.8988L222.343 75.2449",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M132.316 88.6914L84.7676 97.9756",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1382 58.5926C92.0047 57.447 90.8353 55.1029 88.5264 53.3568C86.2175 51.6108 83.6433 51.124 82.7769 52.2697C81.9104 53.4153 83.0798 55.7594 85.3887 57.5055C87.6976 59.2515 90.2717 59.7383 91.1382 58.5926Z",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6346 98.3599C85.5216 98.1477 87.7766 96.8144 87.6713 95.382C87.566 93.9495 85.1403 92.9603 82.2533 93.1725C79.3663 93.3846 77.1112 94.7179 77.2165 96.1503C77.3218 97.5828 79.7476 98.572 82.6346 98.3599Z",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M222.054 75.2327C224.941 75.0205 227.196 73.6872 227.091 72.2548C226.985 70.8223 224.56 69.8331 221.673 70.0453C218.786 70.2574 216.531 71.5907 216.636 73.0231C216.741 74.4556 219.167 75.4448 222.054 75.2327Z",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M241.47 117.088C242.998 110.211 232.988 102.138 219.112 99.0554C205.237 95.9727 192.75 99.0478 191.222 105.924C189.694 112.8 199.704 120.873 213.579 123.956C227.455 127.039 239.942 123.964 241.47 117.088Z",
    fill: "#DBFFF7",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M245.955 116.567L185.146 109.656L187.441 99.3271L245.177 112.564L245.955 116.567Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M167.156 93.3307L213.274 113.853",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M220.745 112.961C221.057 111.559 219.019 109.914 216.193 109.286C213.367 108.658 210.823 109.286 210.512 110.688C210.2 112.09 212.239 113.736 215.065 114.363C217.89 114.991 220.434 114.364 220.745 112.961Z",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M226.454 117.595C226.454 117.595 231.843 119.094 232.894 113.853",
    stroke: "#0A7F69",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1242_188",
    x1: 41,
    y1: 166,
    x2: 243.5,
    y2: 73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ECBA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#128774"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1242_188",
    x1: 146.252,
    y1: 86.4443,
    x2: 155.088,
    y2: 86.4443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ECBA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#128774"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage3211);
export default __webpack_public_path__ + "static/media/image 32 (1) 1.5a028e6cdcae41f0f8e55eca7bc571ab.svg";
export { ForwardRef as ReactComponent };